export default {
  header: {
    title: 'Récompenses',
  },
  content: {
    title: 'Vous avez {{balance}} points',
    description:
      'Dépensez {{amount}}, obtenez {{rewards}} points ! Ajoutez des articles gratuits à votre panier avec vos points gagnés.',
    articles: {
      title: 'Gagnez des points à chaque commande',
      spend_description: 'Chaque {{amount}} dépensé ajoute {{rewards}} points à votre compte.',
      redeem_title: 'Échangez vos points',
      redeem_description:
        "Échangez vos points contre des articles gratuits ! Commencez à gagner des récompenses à partir de {{minSpendingLimit}} points, soit l'équivalent de {{amount}} dépensé",
      discounts_title: 'Découvrez des avantages exclusifs',
      discounts_description: 'Débloquez des offres et remises exclusives.',
    },
  },
};
